import { combineReducers } from 'redux';

import userReducer from './userReducer';

export default combineReducers({
  // Define a top-level state field named `user`, handled by `userReducer`
  // this will be `user` object in redux store
  user: userReducer,
});
